import { useEffect, useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import useStateHandler from '@/hooks/useStateHandler';
import SearchBarIcon from '@/shared-components/icons/components/forms/SearchBarIcon';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

import './index.css';

export default function SearchFollowing({ userId, currentPage, setFollowingCount }) {
  const [query, setQuery] = useState({ username: "" });
  const { cacheHandler } = useStateHandler();
  let cacheVal = cacheHandler.getCacheValue(`${userId}_following`);
  
  const { loading, queryData, loadMoreData } = useQuery(
    `${userId}_following`,
    `${config.apis.api.url}/user/followees/${userId}`,
    query,
    {
      injectToken: true,
      invalidateWhen: [`FOLLOW_ACTION_ON_${userId}`]
    }
  );

  useEffect(() => {
    if (!loading) {
      loadMoreData();
    }
  }, [currentPage]);

  useEffect(() => {
    setFollowingCount(
      cacheVal ? cacheVal["?"].data?.data?.totalDocs : 0
    );
  }, []);

  return (
    <>
      <div className="search-bar-following__search-bar-container">
        <SearchBarIcon className="search-bar-following__search-bar-icon" />

        <input
          type="text"
          className="search-bar-following__search-bar"
          onInput={(e) => setQuery({ username: e.target.value })}
          placeholder="Search"
          spellCheck={false}
          autoComplete="off"
        />
      </div>

      <div className="inspiring_following_popup-search-bar-contents">
        {loading ? (
          <Loader className="search-bar-following__search-loading" thin />
        ) : queryData.data.data.length === 0 ? (
          query.username ? (
            <Text className="search-bar-following__no-results-found" paragraph small>
              No users available for your search query.
            </Text>
          ) : (
            <Text className="search-bar-following__empty" paragraph small>
              It is time to follow your first user!
            </Text>
          )
        ) : (
          <VirtualList
            key={queryData.queryString}
            items={queryData.data}
            onLoadMore={loadMoreData}
          />
        )}
      </div>
    </>
  );
}
